import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import ReactApexChart from "react-apexcharts"
import { useSelector } from "react-redux"
import config from "config/config"
import axios from "axios"

const MonthlyEarnings = () => {
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )
  const { organizations, isConsolidatedView } = useSelector(
    state => state.organizationReducer,
  )
  const userData = useSelector(state => state.Login.userData)

  const [reviews, setReviews] = useState([])
  const [chartOptions, setChartOptions] = useState({
    options: {
      colors: ["#2990DF", "#e76f51"],
      chart: {
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 1.5,
      },
      grid: {
        borderColor: "#f8f8fa",
        row: {
          colors: ["transparent", "transparent"],
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: [], // Months will be dynamically populated
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      legend: {
        show: true,
      },
    },
    series: [], // Average rating trends
  })

  const fetchReviews = async () => {
    try {
      const response = await axios.get(
        `${config.backendUrl}/yelp/getReviews?integrationIds=${isConsolidatedView
            ? organizations
                .map(org => org.Organization.YelpIntegrations[0].id)
                .join(",")
            : activeOrganization.YelpIntegrations[0].id}`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )

      setReviews(response.data.reviews)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    fetchReviews()
  }, [activeOrganization, isConsolidatedView, organizations])

  useEffect(() => {
    if (reviews && reviews.length > 0) {
      // Process data for the chart
      const monthlyRatings = {}
      const months = new Set()

      reviews.forEach(review => {
        const reviewMonth = new Date(review.reviewDate).toLocaleString(
          "default",
          { month: "short", year: "numeric" },
        )

        months.add(reviewMonth)

        if (!monthlyRatings[reviewMonth]) {
          monthlyRatings[reviewMonth] = { totalRating: 0, reviewCount: 0 }
        }

        const rating = parseFloat(review.rating) // Convert string rating to number
        if (!isNaN(rating)) {
          monthlyRatings[reviewMonth].totalRating += rating
          monthlyRatings[reviewMonth].reviewCount += 1
        }
      })

      // Sort months
      const sortedMonths = Array.from(months).sort(
        (a, b) => new Date(a) - new Date(b),
      )

      // Prepare series data
      const averageRatings = sortedMonths.map(month => {
        const monthData = monthlyRatings[month]
        return monthData
          ? (monthData.totalRating / monthData.reviewCount).toFixed(2)
          : 0 // Default to 0 if no data for the month
      })

      // Update chart options
      setChartOptions(prevOptions => ({
        ...prevOptions,
        options: {
          ...prevOptions.options,
          xaxis: {
            ...prevOptions.options.xaxis,
            categories: sortedMonths,
          },
        },
        series: [
          {
            name: "Average Rating",
            data: averageRatings,
          },
        ],
      }))
    }
  }, [reviews])

  return (
    <React.Fragment>
      <Card
        className="br"
        style={{
          overflowY: "auto",
          minHeight: "453px",
          maxHeight: "453px",
          marginBottom: "1rem",
        }}
      >
        <CardBody>
          <h4 className="card-title mb-4">Yelp Ratings Trends</h4>

          <Row className="text-center mt-4">
            <Col xs="12">
              <p className="text-muted">
                This chart displays the monthly average ratings for Yelp
                reviews.
              </p>
            </Col>
          </Row>

          <div
            id="yelp-ratings-chart"
            className="morris-charts morris-charts-height"
            dir="ltr"
          >
            <ReactApexChart
              options={chartOptions.options}
              series={chartOptions.series}
              type="line"
              height="300"
            />
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default MonthlyEarnings
